import { render, staticRenderFns } from "./booking_info.vue?vue&type=template&id=4a547320&scoped=true&lang=pug"
import script from "./booking_info.vue?vue&type=script&lang=js"
export * from "./booking_info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a547320",
  null
  
)

export default component.exports